import {BrowserModule} from '@angular/platform-browser';
import {NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {AppRoutingModule} from './app-routing.module';
import {AnalyticsModule} from '@wdpr/angular-analytics';
import {sprintf} from 'sprintf-js';
import {environment} from '../environments/environment';
import {AppComponent} from './app.component';
import {AvailabilitySelectorComponent} from './features/availability-selector/availability-selector.component';
import {AvailabilityCalendarComponent} from './features/availability-calendar/availability-calendar.component';
import {RequestExecutor} from './shared/libraries/request-executor';
import {ApiService} from './shared/services/api.service';
import {TranslationsService} from './shared/services/translations.service';
import {ConfigService} from './shared/services/config.service';
import {CookieService} from 'ngx-cookie-service';
import {TranslatePipe} from './shared/pipes/translate.pipe';
import {DateHandler} from './shared/libraries/date-handler';
import {LocaleHandler} from './shared/libraries/locale-handler';
import {SegmentHandler} from './shared/libraries/segment-handler';
import {ConversationId} from './shared/libraries/conversation-id';
import {AnalyticsHandler} from './shared/libraries/analytics-handler';
import { NotFoundComponent } from './features/not-found/not-found.component';

@NgModule({
    declarations: [
        AppComponent,
        AvailabilitySelectorComponent,
        AvailabilityCalendarComponent,
        TranslatePipe,
        NotFoundComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        AnalyticsModule
    ],
    providers: [
        ConversationId,
        RequestExecutor,
        ApiService,
        DateHandler,
        LocaleHandler,
        SegmentHandler,
        AnalyticsHandler,
        CookieService,
        ConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: (config: ConfigService) => () => {
                return config.loadConfig()
                    .then((result: any) => {
                        return result;
                    })
                    .catch((err) => {
                        return err;
                    });
            },
            deps: [ConfigService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (translations: TranslationsService) => () => {
                return translations.loadTranslations()
                    .then((result: any) => {
                        return result;
                    })
                    .catch((err) => {
                        return err;
                    });
            },
            deps: [TranslationsService],
            multi: true
        },
        {
            provide: 'PAGE_KEY_URL_ENDPOINT',
            useFactory: (localeHandler: LocaleHandler) => {
                return sprintf(
                    `${environment.apiConfiguration.basePath}${environment.apiConfiguration.paths.pageKeyData}`,
                    [localeHandler.getCurrentPreferredLanguage()]
                );
            },
            deps: [LocaleHandler]
        },
        {
            provide: 'PAGE_KEY_TEMPLATE',
            useValue: ['brand','locale','pageId']
        }
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule { }
